var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"headerMenu"}},[_c('el-tabs',{attrs:{"value":_vm.curFirstMenu},on:{"tab-click":_vm.tabClick}},_vm._l((_vm.menuList),function(item){return _c('el-tab-pane',{key:item.id,attrs:{"label":item.name,"name":item.id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }